<template>
  <base-material-card
    color="indigo"
    icon="mdi-text-box-multiple-outline"
    inline
    class="px-5 py-3"
  >
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">
        {{ title }}
      </div>
    </template>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-text-field
          v-model="visitOperationsSearch"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
        />
      </v-col>
    </v-row>

    <v-divider class="mt-3" />
    <shop-machine-visit-operation-dialog
      :show="showEditDialog"
      :shop-machine-visit-operation-id="shopMachineVisitOperaionId"
      :method="shopMachineVisitDialogMethod"
      @change-edit-dialog="changeEditDialog"
    />
    <v-data-table
      :headers="localizationOperationHeaders"
      :items="visitOperationItems"
      :search.sync="visitOperationsSearch"
      :sort-by="['visitDate']"
      :sort-desc="[true]"
      :loading="visitOperationsLoading"
    >
      <template v-slot:top>
        <v-toolbar
          flat
          color="white"
        >
          <v-spacer />
        </v-toolbar>
      </template>
      <template v-slot:item.visitDate="{ item }">
        {{ item.visitDate | formatLongDate }}
      </template>
      <template v-slot:item.withdraw="{ item }">
        {{ item.withdraw | formatNumber }}
      </template>
      <template v-slot:item.refund="{ item }">
        {{ item.refund | formatNumber }}
      </template>
      <template v-slot:item.refill="{ item }">
        {{ item.refill | formatNumber }}
      </template>
      <template v-slot:item.returnWithDraw="{ item }">
        {{ item.returnWithDraw | formatNumber }}
      </template>
      <template v-slot:item.depositToPay="{ item }">
        {{ item.depositToPay | formatNumber }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          color="success"
          class="px-1 ml-1"
          fab
          x-small
        >
          <v-icon @click="editItem(item)">
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </base-material-card>
</template>

<script>
  import axios from 'axios'
  import filters from '@/common/filters'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const shopMachineVisitOperationsRespository = repositoryFactory.get('shopMachineVisitOperations')

  export default {
    name: 'Operations',
    components: {
      shopMachineVisitOperationDialog: () => import('./ShopMachineVisitOperationDialog'),
    },
    mixins: [filters],
    data: () => ({
      visitOperationItems: [],
      visitOperationsItems: [],
      visitOperationsSearch: undefined,
      visitOperationsLoading: false,
      showErrorMessage: false,
      errorMessage: '',
      showEditDialog: false,
      shopMachine: {
        shop: {
        },
        machine: {

        },
      },
      shopMachineVisitOperaionId: null,
      shopMachineVisitDialogMethod: 'add',
    }),
    computed: {
      title: {
        get () {
          return this.$t('operations')
        },
      },
      localizationOperationHeaders () {
        return [
          {
            text: this.$t('tables.shopMachineVisitOperation.visitDate'),
            value: 'visitDate',
          },
          {
            text: this.$t('tables.shopMachineVisitOperation.userName'),
            value: 'createdByUserUserName',
          },
          {
            text: this.$t('tables.shopMachineVisitOperation.withdraw'),
            value: 'withdraw',
          },
          {
            text: this.$t('tables.shopMachineVisitOperation.refund'),
            value: 'refund',
          },
          {
            text: this.$t('tables.shopMachineVisitOperation.refill'),
            value: 'refill',
          },
          {
            text: this.$t('tables.shopMachineVisitOperation.returnWithDraw'),
            value: 'returnWithDraw',
          },
          {
            text: this.$t('tables.shopMachineVisitOperation.depositToPay'),
            value: 'depositToPay',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
          },
        ]
      },
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        var self = this
        var id = self.$route.params.id
        self.visitOperationsLoading = true
        axios.all([shopMachineVisitOperationsRespository.get(id)])
          .then(axios.spread((shopMachineVisitoperationResponse) => {
            self.visitOperationsLoading = false
            self.visitOperationItems = shopMachineVisitoperationResponse.data.data
          })).catch(errors => {
            self.showErrorMessage = true
            if (errors.response.status === 400) {
              self.errorMessage = errors.response.data.errorMessages[0]
            } else {
              self.errorMessage = errors.message
            }
            self.visitMarkersLoading = false
            self.visitOperationsLoading = false
          })
      },
      editItem (item) {
        this.shopMachineVisitDialogMethod = 'edit'
        this.shopMachineVisitOperaionId = item.id
        this.showEditDialog = true
      },
      changeEditDialog () {
        this.showEditDialog = false
        this.fetchData()
      },
    },
  }
</script>
